import { render, staticRenderFns } from "./AppointmentButtons.vue?vue&type=template&id=c9fa448e&scoped=true"
import script from "./AppointmentButtons.vue?vue&type=script&lang=js"
export * from "./AppointmentButtons.vue?vue&type=script&lang=js"
import style0 from "./AppointmentButtons.vue?vue&type=style&index=0&id=c9fa448e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fa448e",
  null
  
)

export default component.exports